import React, { createRef, useEffect } from 'react';

import classNames from 'classnames';
import Prism from 'prismjs';
import 'prismjs/components/prism-scss.min';
import 'prismjs/components/prism-jsx.min';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.min';
import PropTypes from 'prop-types';

const PrismCode = (props) => {
	const ref = createRef();

	useEffect(() => {
		if (ref && ref.current) {
			Prism.highlightElement(ref.current);
		}
		return () => {};
	}, [ref]);

	const { className, code, language, plugins, rounded, style } = props;
	return (
		<pre
			className={classNames('prismjs-code', plugins, className, {
				[`rounded${rounded !== 'default' ? `-${rounded}` : ''}`]: rounded,
			})}
			style={style}
		>
			<code className={`language-${language}`} ref={ref}>
				{code.trim()}
			</code>
		</pre>
	);
};
PrismCode.propTypes = {
	code: PropTypes.string.isRequired,
	language: PropTypes.string.isRequired,
	className: PropTypes.string,
	plugins: PropTypes.string,
	rounded: PropTypes.oneOf([
		'default',
		0,
		1,
		2,
		3,
		'bottom',
		'top',
		'circle',
		'end',
		'start',
		'pill',
	]),
	// eslint-disable-next-line react/forbid-prop-types
	style: PropTypes.object,
};
PrismCode.defaultProps = {
	className: null,
	plugins: null,
	rounded: 2,
	style: null,
};

export default PrismCode;
